export enum SalesChannelConnectionStatus {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  INVALID = "invalid",
  AVAILABLE = "available",
}
